import type { CouncilApproval } from '@/types/api'

import { apiClient } from '@/lib/api/client'
import {
  councilApprovalListSchema,
  councilApprovalSchema,
} from '@/lib/api/schemas'

export function listApprovals(companyId: string): Promise<CouncilApproval[]> {
  return apiClient.requestValidated(
    `/companies/${encodeURIComponent(companyId)}/approvals`,
    councilApprovalListSchema,
  )
}

export function approveApproval(approvalId: string): Promise<CouncilApproval> {
  return apiClient.requestValidated(
    `/approvals/${encodeURIComponent(approvalId)}/approve`,
    councilApprovalSchema,
    { method: 'POST' },
  )
}

export function rejectApproval(approvalId: string): Promise<CouncilApproval> {
  return apiClient.requestValidated(
    `/approvals/${encodeURIComponent(approvalId)}/reject`,
    councilApprovalSchema,
    { method: 'POST' },
  )
}
